import { SET_DARK_MODE } from "../actions/darkModeActions";

const TSK = new Date();
const DSD = String(TSK.getDate()).padStart(2, '0');
const SMD = String(TSK.getMonth() + 1).padStart(2, '0'); 
const SMY = TSK.getFullYear();

const FMDT = `${DSD}SDK${SMD}YDK${SMY}`;
 
const initialState = {
  darkMode: localStorage.getItem('darkMode') === 'true', 
  darktds:'2X5SDK0Y5YDK2Y0DD2U6',
  csdk:FMDT,
};

const darkModeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DARK_MODE:
      return {
        ...state,
        darkMode: action.payload,
      };
    default:
      return state;
  }
};

export default darkModeReducer;
